// extracted by mini-css-extract-plugin
module.exports = {"radio":"styles_radio__12BcK","icon":"styles_icon__LovlH"};